import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Turbolinks from 'turbolinks'
import { helpers, urlHelpers, prismicHelpers } from '../../helpers'

/**
* CarouselSlide Component
* Child of Carousel Component
*
* Displays a slide for the Carousel using given slide data. Manages slide's
* impression and click analytics as well.
*/
class CarouselSlide extends Component {
  constructor(props) {
    super(props)

    this.uid = helpers.generateID('carousel-slide')

    this.getSlideLink = this.getSlideLink.bind(this)
    this.onClickHandler = this.onClickHandler.bind(this)
    this.renderImage = this.renderImage.bind(this)
  }

  /**
  * Formats slide's link to include a `ref` of the slide's `creativeName`.
  */
  getSlideLink() {
    const creativeName = this.props.slide.creativeName


    const url = this.props.slide.link

    if (!creativeName) {
      return url
    }

    return urlHelpers.addRef(url, creativeName)
  }

  /**
  * On click event handler for when a user clicks the carousel slide. Tracks
  * the promo as having been clicked and then takes the user to the slide's
  * destination.
  */
  onClickHandler(e) {
    e.preventDefault()
    $.track('promo click', {
      id: this.props.slide.promoId,
      name: this.props.slide.promoName,
      creative: this.props.slide.creativeName,
      position: `slide_${this.props.index}`,
    }, () => {
      Turbolinks.visit(this.getSlideLink())
    })
  }

  /**
  * Renders the carousel slide and styles the background color if one is set.
  */
  renderImage() {
    let figureStyles = {}

    if (this.props.slide.backgroundColor) {
      figureStyles = {
        backgroundColor: `#${this.props.slide.backgroundColor}`,
      }
    }

    return (
      <figure style={figureStyles}>
        <img
          className="is-lazy fade-in owl-lazy"
          data-src={this.props.slide.image.url}
          data-srcset={prismicHelpers.formatSrcset(this.props.slide.image)}
          alt={this.props.slide.image.alt}
        />
      </figure>
    )
  }

  render() {
    return (
      <a
        href={this.getSlideLink()}
        aria-label={this.props.slide.title}
        className={`${this.uid} is-${this.props.slide.type}`}
        data-promo-trackable
        data-promo-id={this.props.slide.promoId}
        data-promo-name={this.props.slide.promoName}
        data-promo-creative={this.props.slide.creativeName}
        data-promo-position={`slide_${this.props.index}`}
        onClick={this.onClickHandler}
      >
        { this.renderImage() }
      </a>
    )
  }
}

CarouselSlide.propTypes = {
  slide: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
}

export default CarouselSlide
